import { render, staticRenderFns } from "./legWorkInfo.vue?vue&type=template&id=2a7865c4&"
import script from "./legWorkInfo.vue?vue&type=script&lang=js&"
export * from "./legWorkInfo.vue?vue&type=script&lang=js&"
import style0 from "./legWorkInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports